import type { Bilingual } from '../i18n/LanguageContext';

export interface Project {
  id: string;
  /** Thumbnail artwork (public/assets). */
  image: string;
  title: Bilingual;
  description: Bilingual;
  tag: Bilingual;
  /** Badge color for the tag. */
  tagClass: string;
  stats: { likes: string; users: string };
}

export const projects: Project[] = [
  {
    id: 'smart-car',
    image: '/assets/smart car.png',
    title: { en: 'Smart Car', ar: 'السيارة الذكية' },
    description: {
      en: 'Autonomous obstacle-avoiding car with camera and distance sensors.',
      ar: 'سيارة ذاتية القيادة تتجنب العوائق بكاميرا وحساسات مسافة.',
    },
    tag: { en: 'Simulation', ar: 'محاكاة' },
    tagClass: 'bg-sky-500/90',
    stats: { likes: '1.2K', users: '320' },
  },
  {
    id: 'smart-house',
    image: '/assets/smart house.png',
    title: { en: 'Smart House', ar: 'المنزل الذكي' },
    description: {
      en: 'Automate lights, security, and appliances with smart logic.',
      ar: 'أتمتة الإضاءة والأمان والأجهزة المنزلية بمنطق ذكي.',
    },
    tag: { en: 'Simulation', ar: 'محاكاة' },
    tagClass: 'bg-sky-500/90',
    stats: { likes: '987', users: '245' },
  },
  {
    id: 'smart-garden',
    image: '/assets/smart garden.png',
    title: { en: 'Smart Garden', ar: 'الحديقة الذكية' },
    description: {
      en: 'Monitor soil moisture, control watering, and grow smarter.',
      ar: 'راقب رطوبة التربة، وتحكم بالري، وازرع بذكاء.',
    },
    tag: { en: 'Simulation', ar: 'محاكاة' },
    tagClass: 'bg-sky-500/90',
    stats: { likes: '842', users: '198' },
  },
  {
    id: 'sumo-robot',
    image: '/assets/competition arena.png',
    title: { en: 'Sumo Robot', ar: 'روبوت السومو' },
    description: {
      en: 'Build and battle your sumo robot in the ultimate arena.',
      ar: 'ابنِ روبوت السومو الخاص بك وخض المعارك في الساحة الكبرى.',
    },
    tag: { en: 'Competition', ar: 'منافسة' },
    tagClass: 'bg-orange-500/90',
    stats: { likes: '1.5K', users: '410' },
  },
];
